/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RemovalReason {
  scope = 'scope',
  target_removed = 'target_removed',
}
